import { Toaster } from "components/notification/Toaster";
import { func_serviceHandling, isArrayNotEmpty, isNumberValid, isObjectNotEmpty } from "functions";
import { useDispatch } from "react-redux";
import { 
    getOutletLogs_request, getOutletLogs_success, getOutletLogs_failure, getAllOutlets_failure, getAllOutlets_request, getAllOutlets_success, 
    getOutletSTList_failure, getOutletSTList_request, getOutletSTList_success, removeTotalRequest, getNonDeletedOutlets_request, 
    getNonDeletedOutlets_success, getNonDeletedOutlets_failure, activateOutlet_request, activateOutlet_success, activateOutlet_failure, 
    suspendOutlet_request, suspendOutlet_success, suspendOutlet_failure, setSuspendDate_request, setSuspendDate_success, setSuspendDate_failure,
    removeSuspendDate_request, removeSuspendDate_success, removeSuspendDate_failure,
    deleteOutlet_request, deleteOutlet_success, deleteOutlet_failure,
    revertDeleteOutlet_request, revertDeleteOutlet_success, revertDeleteOutlet_failure,
    getAllOutletLogs_request, getAllOutletLogs_success, getAllOutletLogs_failure,
    getAllOutletSTList_request, getAllOutletSTList_success, getAllOutletSTList_failure,
    addOutletActivationExclusion_request, addOutletActivationExclusion_success, addOutletActivationExclusion_failure,
    removeOutletActivationExclusion_request, removeOutletActivationExclusion_success, removeOutletActivationExclusion_failure,
} from "../slices/outlet.slices";
import usePromiseInstance_authorization from "./config";


export default function useOutletsActions() {
    const dispatch = useDispatch();
    const request = usePromiseInstance_authorization();

    // Including deleted outlets
    function getAllOutlets(pageNo, pageSize, sort, filterOptions = {}) {
        dispatch(getAllOutlets_request());

        request(getAllOutlets_request, (axios) => {
            let paramObj = {
                limit: 0,
                comId: filterOptions?.comId,
                ...filterOptions
            }
    
            let url = func_serviceHandling.createUrlWithParams('/ComInfo/TransactionHistory/GetAllOutlet', paramObj);

            axios.get(url)
                .then((response) => {
                    dispatch(getAllOutlets_success(response.data));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to get all outlets";
                    Toaster({ type: "error", msg });

                    dispatch(getAllOutlets_failure(msg));
                })
        })
    }


    function getOutletSTList(pageNo, pageSize, sort, filterOptions) {
        dispatch(getOutletSTList_request());

        request(getOutletSTList_request, (axios) => {
            let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
            let offset = isOffsetValid? pageNo * pageSize:0;
            
            let paramObj = {
                offset: offset,
                limit: pageSize,
                sort: sort,
                ...filterOptions
            }
    
            let url = func_serviceHandling.createUrlWithParams('/ComInfo/TransactionHistory/GetOutletST', paramObj);
            if (isArrayNotEmpty(filterOptions?.outletIDs)) {
                filterOptions.outletIDs.map((obj) => {
                    url += "&outletID=" + obj?.outletID;
                })
            }

            axios.get(url)
                .then((response) => {
                    dispatch(getOutletSTList_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to get outlet ST list";
				    Toaster({ type: "error", msg });

                    dispatch(getOutletSTList_failure(msg));
                })
        })
    }

    function getAllOutletSTList(pageSize, filterOptions) {
        dispatch(getAllOutletSTList_request());

        request(getAllOutletSTList_request, (axios) => {
            
            let paramObj = {
                limit: pageSize,
                ...filterOptions
            }
    
            let url = func_serviceHandling.createUrlWithParams('/ComInfo/TransactionHistory/GetOutletST', paramObj);
            if (isArrayNotEmpty(filterOptions?.outletIDs)) {
                filterOptions.outletIDs.map((obj) => {
                    url += "&outletID=" + obj?.outletID;
                })
            }

            axios.get(url)
                .then((response) => {
                    dispatch(getAllOutletSTList_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to get outlet ST list";
				    Toaster({ type: "error", msg });

                    dispatch(getAllOutletSTList_failure(msg));
                })
        })
    }

    // outlets not including deleted outlets
    function getNonDeletedOutlets(pageNo, pageSize, sort, filterOptions = {}) {
        dispatch(getNonDeletedOutlets_request());

		let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;
		let comID_validated = filterOptions?.comID? filterOptions.comID:"";

		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort,
            ...filterOptions
		}

		let url = func_serviceHandling.createUrlWithParams('/ComInfo/GetOutlets/' + comID_validated, paramObj)

		request(getNonDeletedOutlets_request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(getNonDeletedOutlets_success(details));
				})
				.catch(function (error) {
					// handle error
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to get existing outlets";
				    Toaster({ type: "error", msg });

					dispatch(getNonDeletedOutlets_failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function activateOutlet(comId, locationId) {
        dispatch(activateOutlet_request());

        request(activateOutlet_request, (axios) => {
            let comId_formatted = "";
            if (isNumberValid(comId)) comId_formatted = comId;

            let paramObj = {
                comId: comId_formatted,
                locId: locationId
            };
            let url = func_serviceHandling.createUrlWithParams('/ComInfo/AccountControl/ActivateOutletByLocId', paramObj);

			axios.put(url)
				.then((response) => {
					// handle success
					dispatch(activateOutlet_success(response));
					Toaster({ type: "success", msg: "Successfully activated Outlet(s)"});
				})
				.catch((error) => {
					// handle error
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to activate outlet";
				    Toaster({ type: "error", msg });

					dispatch(activateOutlet_failure(error));
				})
        })
    }

    function suspendOutlet(comId, locationId) {
        dispatch(suspendOutlet_request());

        request(suspendOutlet_request, (axios) => {
            let comId_formatted = "";
            if (isNumberValid(comId)) comId_formatted = comId;

            let paramObj = {
                comId: comId_formatted,
                locId: locationId
            };
            let url = func_serviceHandling.createUrlWithParams('/ComInfo/AccountControl/SuspendOutletByLocId', paramObj);

			axios.put(url)
				.then((response) => {
					// handle success
					dispatch(suspendOutlet_success(response));
					Toaster({ type: "success", msg: "Successfully suspended Outlet(s)"});
				})
				.catch((error) => {
					// handle error
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to suspend outlet";
				    Toaster({ type: "error", msg });

					dispatch(suspendOutlet_failure(error));
				})
        })
    }

    function deleteOutlet(comId, locationId) {
        dispatch(deleteOutlet_request());

        request(deleteOutlet_request, (axios) => {
            let comId_formatted = "";
            if (isNumberValid(comId)) comId_formatted = comId;

            let paramObj = {
                comId: comId_formatted,
                locId: locationId
            };
            let url = func_serviceHandling.createUrlWithParams('/ComInfo/AccountControl/DeleteOutletByLocId', paramObj);

            axios.put(url)
                .then((response) => {
                    dispatch(deleteOutlet_success(response));
                    Toaster({ type: "success", msg: "Successfully deleted Outlet(s)" });
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage ? error.response.data.exceptionMessage : "Failed to delete outlet";
                    Toaster({ type: "error", msg });

                    dispatch(deleteOutlet_failure(error));
                })
        })
    }

    function revertDeleteOutlet(comId, locationId) {
        dispatch(revertDeleteOutlet_request());

        request(revertDeleteOutlet_request, (axios) => {
            let comId_formatted = "";
            if (isNumberValid(comId)) comId_formatted = comId;

            let paramObj = {
                comId: comId_formatted,
                locId: locationId
            };
            let url = func_serviceHandling.createUrlWithParams('/ComInfo/AccountControl/RevertDeleteOutletByLocId', paramObj);

            axios.put(url)
                .then((response) => {
                    dispatch(revertDeleteOutlet_success(response));
                    Toaster({ type: "success", msg: "Successfully reverted deleted Outlet(s)" });
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage ? error.response.data.exceptionMessage : "Failed to revert deleted outlet";
                    Toaster({ type: "error", msg });

                    dispatch(revertDeleteOutlet_failure(error));
                })
        })
    }

    function getOutletLogs(pageNo, pageSize, sort, filterOptions = {}) {
        dispatch(getOutletLogs_request());

        request(getOutletLogs_request, (axios) => {
            let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
            let offset = isOffsetValid? pageNo * pageSize:0;
            
            let paramObj = {
                offset: offset,
                limit: pageSize,
                sort: sort,
                ...filterOptions
            }

            let url = func_serviceHandling.createUrlWithParams('/ComInfo/PerformedJournal/GetPerformedLog', paramObj);
            if (isArrayNotEmpty(filterOptions?.outletIDs)) {
                filterOptions.outletIDs.map((obj) => {
                    url += "&outletID=" + obj?.outletID;
                })
            }
            
            axios.get(url)
                .then((response) => {
                    dispatch(getOutletLogs_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load outlet logs";
				    Toaster({ type: "error", msg });

                    dispatch(getOutletLogs_failure(msg));
                })
        })
    }

    function getAllOutletLogs(pageSize, filterOptions = {}) {
        dispatch(getAllOutletLogs_request());

        request(getAllOutletLogs_request, (axios) => {
            
            let paramObj = {
                limit: pageSize,
                ...filterOptions
            }

            let url = func_serviceHandling.createUrlWithParams('/ComInfo/PerformedJournal/GetPerformedLog', paramObj);
            if (isArrayNotEmpty(filterOptions?.outletIDs)) {
                filterOptions.outletIDs.map((obj) => {
                    url += "&outletID=" + obj?.outletID;
                })
            }
            
            axios.get(url)
                .then((response) => {
                    dispatch(getAllOutletLogs_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load outlet logs";
				    Toaster({ type: "error", msg });

                    dispatch(getAllOutletLogs_failure(msg));
                })
        })
    }

    function updateSuspendDate(comId, locationId, suspendDate) {
        dispatch(setSuspendDate_request());

        request(setSuspendDate_request, (axios) => {
            let paramObj = {
                comId: comId,
                locId: locationId,
                suspendDate: suspendDate
            }
    
            let url = func_serviceHandling.createUrlWithParams('/ComInfo/AccountControl/SetSuspendOutletDateByLocId', paramObj);
            axios.put(url)
                .then((response) => {
                    dispatch(setSuspendDate_success());

                    Toaster({
                        type: "success",
                        msg: "Successfully set suspend date"
                    })
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to set suspend date";

                    dispatch(setSuspendDate_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function addOutletActivationExclusion(comId, locationId) {
        dispatch(addOutletActivationExclusion_request());

        request(addOutletActivationExclusion_request, (axios) => {
            let paramObj = {
                comId: comId,
                locationId: locationId
            };
            let url = func_serviceHandling.createUrlWithParams('/ComInfo/AccountControl/AddOutletActivationExclusion', paramObj);

            axios.post(url)
                .then((response) => {
                    dispatch(addOutletActivationExclusion_success(response));
                    Toaster({ type: "success", msg: "Successfully moved Outlet(s) to Activation Excluded" });
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage ? error.response.data.exceptionMessage : "Failed to add outlet activation exclusion";
                    Toaster({ type: "error", msg });

                    dispatch(addOutletActivationExclusion_failure(error));
                })
        })
    }

    function removeSuspendDate(comId, locationId) {
        dispatch(removeSuspendDate_request());

        request(removeSuspendDate_request, (axios) => {
            if (!(comId && locationId)) {
                dispatch(removeSuspendDate_failure("Invalid COM ID or Outlet ID"));
                Toaster({ type: "error", msg: "Invalid COM ID or Outlet ID" });
                return;
            }

            let comId_formatted = encodeURIComponent(comId);
            let locationId_formatted = encodeURIComponent(locationId);

            let url = '/ComInfo/RemoveOutletSuspendDateByLocId/' + comId_formatted + '/' + locationId_formatted;

            axios.delete(url)
                .catch((error) => {
                    // Fallback to query-string format if backend route is configured differently.
                    let isRouteMismatch = error?.response?.status === 404 || error?.response?.status === 405;
                    if (isRouteMismatch) {
                        let fallbackUrl = func_serviceHandling.createUrlWithParams('/ComInfo/RemoveOutletSuspendDateByLocId', {
                            comId,
                            locId: locationId
                        });
                        return axios.delete(fallbackUrl);
                    }
                    throw error;
                })
                .then((response) => {
                    dispatch(removeSuspendDate_success(response));
                    Toaster({ type: "success", msg: "Successfully removed suspend date" });
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage ? error.response.data.exceptionMessage : "Failed to remove suspend date";
                    Toaster({ type: "error", msg });

                    dispatch(removeSuspendDate_failure(error));
                })
        })
    }

    function removeOutletActivationExclusion(comId, locationId) {
        dispatch(removeOutletActivationExclusion_request());

        request(removeOutletActivationExclusion_request, (axios) => {
            let paramObj = {
                comId: comId,
                locationId: locationId
            };
            let url = func_serviceHandling.createUrlWithParams('/ComInfo/AccountControl/RemoveOutletActivationExclusion', paramObj);

            axios.delete(url)
                .then((response) => {
                    dispatch(removeOutletActivationExclusion_success(response));
                    Toaster({ type: "success", msg: "Successfully moved Outlet(s) to Suspended" });
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage ? error.response.data.exceptionMessage : "Failed to remove outlet activation exclusion";
                    Toaster({ type: "error", msg });

                    dispatch(removeOutletActivationExclusion_failure(error));
                })
        })
    }

    function getFilteredAccountCodeList() {
        return new Promise((resolve, reject) => {
            request(undefined, (axios) => {
                axios.get('/BillingSetup/GetFilteredAccountCodeList')
                    .then((response) => {
                        resolve(response?.data);
                    })
                    .catch((error) => {
                        let msg = error?.response?.data?.exceptionMessage ? error.response.data.exceptionMessage : "Failed to load account code list";
                        Toaster({ type: "error", msg });

                        reject(error);
                    })
            })
        });
    }

    return {
        getAllOutlets, getOutletSTList, getAllOutletSTList, getNonDeletedOutlets, 
        activateOutlet, suspendOutlet, deleteOutlet, revertDeleteOutlet,
        addOutletActivationExclusion, removeOutletActivationExclusion,
        getOutletLogs, getAllOutletLogs, updateSuspendDate, removeSuspendDate,
        getFilteredAccountCodeList
    }
}